import Stepper from 'components/Stepper/Stepper';
import './PostGeneratorHeader.scss';

import StepTitle from '../StepTitle/StepTitle';
import {postGeneratorSteps} from '../typescript';

interface IPostGeneratorHeaderProps {
  step: string;
}

const PostGeneratorHeader = ({step}: IPostGeneratorHeaderProps) => {
  const stepsMap: {[key: string]: number} = {
    [postGeneratorSteps.manageBeers]: 1,
    [postGeneratorSteps.postType]: 2,
    [postGeneratorSteps.postTemplate]: 3,
  };

  return (
    <div className="post-generator-header">
      <div className="post-generator-header__stepper">
        <Stepper step={stepsMap[step]} stepsNumber={3} />
      </div>
      <StepTitle step={step} />
    </div>
  );
};

export default PostGeneratorHeader;
